<template lang="pug">
.v-article-poster.article-poster
	a.article-poster__link(:href="article.link" v-if="article.link" :aria-label="article.name")
	.article-poster__visual.flc
		v-product-image.article-poster__image(:src="article.image ? article.image.medium : null" :sources="computedSourcesMedium")
		.article-poster__status(v-if="article.status && article.status.length")
			v-status(:status="article.status")
	.article-poster__title.flc(v-if="article.name") {{article.name}}
</template>

<script>

export default {
	props: {
		article: {
			type: Object,
			default: null
		}
	},
	
	computed: {
		computedSourcesMedium() {
			let result = null;
			if (this.article.image) {
				result = [
					{
						'src': this.article.image.medium,
						'size': '1x'
					},
					{
						'src': this.article.image.medium_2x,
						'size': '2x'
					}
				];
			}
			return result;
		}
	}
};
</script>